import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Experience from "./experience";
import Publications from "./publications";
import Music from "./music";
import Home from "./home";
import Details from "./details";
import FreeSkateScores from "./skates";

const Navigation = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/details" element={<Details />} />
      <Route path="/publications" element={<Publications />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/music" element={<Music />} />
      <Route path="/freeskatescores" element={<FreeSkateScores />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Navigation;
